<div>
    <span class="text-left">{{boxTitle ? boxTitle : '&nbsp;'}}</span>
    <div class="d-flex flex-row">
        <div class="wccr-box px-p-5 border d-flex flex-column justify-content-center text-center" [ngClass]="boxClass"
            (click)="onClick(ccr.legalEntity.entityId, ccr.counterParty)">
            <span class="m-0">{{ccr ? ccr.legalEntity.code: ''}}</span><br />
            <span class="m-0"><strong>{{ccr ? ccr.ccrFormatted: 'NONE'}}</strong></span><br />
            <span [ngClass]="(ccr && ccr.counterParty && ccr.counterParty.length > 8) ? 'fs-12px' : ''">{{ccr ? ccr.counterParty: ''}}</span>
        </div>
    </div>
</div>
